
    import { Image } from 'antd';
    import type { ImageProps } from 'antd/lib/image/index';
    import wrapper from './next-wrapper';

    export type BLProFormImageProps =ImageProps;

    const BLProFormImage = wrapper<BLProFormImageProps>(Image, 'BLProFormImage');

    export default BLProFormImage;
